import { SUCCESS_LOADING_CHECKLIST_ITEMS } from 'constants'

const initialState = {};

export default (state = initialState, action) => {
  switch(action.type){
    case SUCCESS_LOADING_CHECKLIST_ITEMS:
      return Object.assign({}, state, {
        [action.contactId] : {
          [action.schoolId] : action.payload.result.objects
        }
      });

    default:
      return state;
  }
};